import { NavLink, useNavigate } from "react-router-dom";
import { FaBars, FaHome, FaLock, FaMoneyBill, FaUser, FaDelicious, FaServicestack, FaComments, FaStarOfLife } from "react-icons/fa";
import { MdMessage, MdContacts, MdFeaturedPlayList, MdCloudDone, MdEscalator, MdAddComment, MdOutlineHomeRepairService, MdStars } from "react-icons/md";
import { BiAnalyse, BiSearch, BiLogOut, BiImageAdd, BiMessageSquareAdd } from "react-icons/bi";
import { BiCog } from "react-icons/bi";
import { RiCommunityFill, RiInformationLine, RiLayoutBottom2Line, RiInsertRowBottom } from "react-icons/ri";
import { HiOutlineUserAdd } from "react-icons/hi";
import { CgDetailsMore } from "react-icons/cg";

import { GrUserExpert } from "react-icons/gr";
import { BsCartCheck } from "react-icons/bs";
import { useState, useContext } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SidebarMenu from "./SidebarMenu";
import {
  Button
} from "reactstrap";
import AuthContext from "../../context/AuthProvider";

const routes = [
  {
    path: "/",
    name: "Dashboard",
    icon: <FaHome />,
  },
  {
    path: "/sliders",
    name: "Slider",
    icon: <FaDelicious />,
    subRoutes: [
      {
        path: "/sliders/add",
        name: "Add Slider",
        icon: <BiImageAdd />,
      },
      {
        path: "/sliders/view",
        name: "Slider List",
        icon: <CgDetailsMore />,
      }
    ],
  },
  {
    path: "/contacts",
    name: "Contacts",
    icon: <MdContacts />,
    subRoutes: [
      {
        path: "/contacts/add",
        name: "Add Contact",
        icon: <HiOutlineUserAdd />,
      },
      {
        path: "/contacts/view",
        name: "Contact Details",
        icon: <CgDetailsMore />,
      }
    ],
  },
  {
    path: "/client-testimonials",
    name: "Client Testimonial",
    icon: <FaComments />,
    subRoutes: [
      {
        path: "/testimonials/add",
        name: "Add Testimonial",
        icon: <MdAddComment />,
      },
      {
        path: "/testimonials/view",
        name: "Testimonial Details",
        icon: <CgDetailsMore />,
      }
    ],
  },
  {
    path: "/services",
    name: "Services",
    icon: <FaServicestack />,
    subRoutes: [
      // {
      //   path: "/services/add",
      //   name: "Add Service",
      //   icon: <MdOutlineHomeRepairService />,
      // },
      {
        path: "/services/view",
        name: "Service Details",
        icon: <CgDetailsMore />,
      }
    ],
  },
  {
    path: "/homepage-services",
    name: "Home Page Services",
    icon: <FaServicestack />,
    subRoutes: [
      // {
      //   path: "/homepage-services/add",
      //   name: "Add HomePage Service",
      //   icon: <MdOutlineHomeRepairService />,
      // },
      {
        path: "/homepage-services/view",
        name: "Home Page Service Details",
        icon: <CgDetailsMore />,
      }
    ],
  },
  {
    path: "/community",
    name: "Community Web Portal",
    icon: <RiCommunityFill />,
    subRoutes: [
      // {
      //   path: "/community/web-portal/add",
      //   name: "Add Portal Information",
      //   icon: <MdOutlineHomeRepairService />,
      // },
      {
        path: "/community/web-portal/view",
        name: "Portal Information",
        icon: <RiInformationLine />,
      },
      // {
      //   path: "/community/feature",
      //   name: "Community Feature",
      //   icon: <MdFeaturedPlayList />,
      // }
    ],
  },
  {
    path: "/community/feature",
    name: "Community Feature",
    icon: <RiCommunityFill />,
    subRoutes: [
      {
        path: "/community/feature/add",
        name: "Add Feature",
        icon: <RiInformationLine />,
      },
      {
        path: "/community/feature/view",
        name: "Community Feature Details",
        icon: <MdFeaturedPlayList />,
      }
    ],
  },
  {
    path: "/about",
    name: "About",
    icon: <FaServicestack />,
    subRoutes: [
      // {
      //   path: "/about/add",
      //   name: "Add About",
      //   icon: <MdOutlineHomeRepairService />,
      // },
      {
        path: "/about/view",
        name: "About Details",
        icon: <CgDetailsMore />,
      }
    ],
  },
  {
    path: "/our-experience",
    name: "Our Experience",
    icon: <MdStars />,
    subRoutes: [
      {
        path: "/our-experience/add",
        name: "Add Experience",
        icon: <FaStarOfLife />,
      },
      {
        path: "/our-experience/view",
        name: "Experience Details",
        icon: <CgDetailsMore />,
      }
    ],
  },
  {
    path: "/footer",
    name: "Footer",
    icon: <RiLayoutBottom2Line />,
    subRoutes: [
      // {
      //   path: "/footer/add",
      //   name: "Add Footer Info",
      //   icon: <RiInsertRowBottom />,
      // },
      {
        path: "/footer/view",
        name: "Footer Info Details",
        icon: <CgDetailsMore />,
      }
    ],
  },
  {
    path: "/investment",
    name: "Investment",
    icon: <MdEscalator />,
    subRoutes: [
      // {
      //   path: "/investment/add",
      //   name: "Add investment Info",
      //   icon: <BiMessageSquareAdd />,
      // },
      {
        path: "/investment/view",
        name: "Investment Info Details",
        icon: <CgDetailsMore />,
      }
    ],
  },
  {
    path: "/investment/additional-disburse",
    name: "Investment Additional Disburse",
    icon: <MdEscalator />,
    subRoutes: [
      {
        path: "/investment/additional-disburse/add",
        name: "Add investment disburse Info",
        icon: <BiMessageSquareAdd />,
      },
      {
        path: "/investment/additional-disburse/view",
        name: "Investment Disburse Details",
        icon: <CgDetailsMore />,
      }
    ],
  }
];

const SideBar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const { setAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  const logout = async () => {
      // if used in more components, this should be in context 
      // axios to /logout endpoint 
      setAuth({});
      navigate('/login');
  }

  const inputAnimation = {
    hidden: {
      width: 0,
      padding: 0,
      transition: {
        duration: 0.2,
      },
    },
    show: {
      width: "140px",
      padding: "5px 15px",
      transition: {
        duration: 0.2,
      },
    },
  };

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <>
      <div className="main-container">
        <motion.div
          animate={{
            width: isOpen ? "320px" : "80px",

            transition: {
              duration: 0.5,
              type: "spring",
              damping: 10,
            },
          }}
          className={`sidebar `}
        >
          <div className="top_section">
            <AnimatePresence>
              {isOpen && (
                <motion.h1
                  variants={showAnimation}
                  initial="hidden"
                  animate="show"
                  exit="hidden"
                  className="logo"
                >
                  <img src="/f-logo.png"></img>
                </motion.h1>
              )}
            </AnimatePresence>

            <div className="bars">
              <FaBars onClick={toggle} />
            </div>
          </div>
         
          <section className="routes">
            {routes.map((route, index) => {
              if (route.subRoutes) {
                return (
                  <SidebarMenu key={index}
                    setIsOpen={setIsOpen}
                    route={route}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                  />
                );
              }

              return (
                <NavLink
                  to={route.path}
                  key={index}
                  className="link"
                  activeclassname="active"
                >
                  <div className="icon">{route.icon}</div>
                  <AnimatePresence>
                    {isOpen && (
                      <motion.div
                        variants={showAnimation}
                        initial="hidden"
                        animate="show"
                        exit="hidden"
                        className="link_text"
                      >
                        {route.name}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </NavLink>
                
              );
            })}
            <div className="d-grid gap-2"><Button className="logout" onClick={logout}><BiLogOut />{isOpen && ("Logout")}</Button></div>
            
          </section>
        </motion.div>

        <main>{children}</main>
      </div>
      {/* <Outlet /> */}
    </>
  );
};

export default SideBar;
